// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"4ad592be","96":"fd5d2bb3","160":"41cbbced","165":"f7e35908","495":"1e756073","535":"622b104a"}[chunkId] + ".chunk.js";
};